export enum DocumentType {
    acknowledgement = 'acknowledgement',
    offerLetter = 'offer_letter',
    standardSigningDocument = 'standard_signing_document',
    viewOnly = 'view_only',
}
